import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { PartitionListFeatureGate } from '../Guards/PartitionListFeatureGate'
import { PartitionList } from '../Components/Organisms/PartitionList/PartitionList'

/**
 * Routed Partitions list page.
 */
@Route(RouteID.PARTITION)
export class PartitionListPage extends Component {
    /**
     * @returns Partitions list page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.PARTITION}>
                <PartitionListFeatureGate>
                    <LanguageContextProvider>
                        <PartitionList />
                    </LanguageContextProvider>
                </PartitionListFeatureGate>
            </RouteGuard>
        )
    }
}
